<div class="row">
    <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.thirdPartyCompanyID)"><i class="fas fa-pencil-alt"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.carrierServiceID)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="thirdPartyCompanyID" title="ID"></kendo-grid-column>
            <kendo-grid-column field="thirdPartyCompanyName" title="Name"></kendo-grid-column>
            <kendo-grid-column field="thirdPartyCompanyCode" title="Code"></kendo-grid-column>
            <kendo-grid-column field="cityST" title="City, ST"></kendo-grid-column>
            <kendo-grid-column field="countryAbbrev" title="Country"></kendo-grid-column>
            <kendo-grid-column field="address1" title="Address 1"></kendo-grid-column>
            <kendo-grid-column field="address2" title="Address 2"></kendo-grid-column>
            <kendo-grid-column field="externalCompanyID" title="External ID"></kendo-grid-column>
            <kendo-grid-column field="createDate" title="Created">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.createDate | date: 'M/dd/yy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isEdit || isAdd">
        <!-- Edit form -->
        <third-party-company-form [tableID]="tableID" (onRefresh)="cancelEdit()"></third-party-company-form>
    </div>
</div>
